import React from 'react';
import Button from '@pezeshk-book/ui-kit/button';
import Div from '@pezeshk-book/ui-kit/div';
import Text from '@pezeshk-book/ui-kit/text';
import { SliderItemProps } from './slider-item.props';
import routes from '@routes';
import { UsersActions } from '@store/users/users-action';
import { useDispatch } from 'react-redux';
import { PharmaciesActions } from '@store/pharmacies/pharmacies-actions';
import getParseRoute from '@utils/helpers/parse-route';
import { useParams } from 'next/navigation';
import { LocaleTypes } from '@dictionaries-types';

const SliderItem = ({ title, subTitle, image, route, unit, type, callbackFunction, buttonTitle }: SliderItemProps) => {
  const dispatch = useDispatch();
  const { lang } = useParams<{lang: LocaleTypes}>();
  const handleClick = () => {
    if (route === routes['route.users.index']) {
      dispatch(UsersActions.setFilterItems({
        key: 'serviceType',
        value: 'مشاوره',
        id: '2',
      }));
    } else {
      if (unit && type && callbackFunction) {
        dispatch(PharmaciesActions.setTopSaleDrug({ name: title, unit: unit, type: type }));
        callbackFunction(routes['route.pharmacies.otc']);
      }
    }
  };
  return (
    <Div className={'rounded-lg flex-col flex-1 w-64 md:w-72 self-center shadow-lg bg-darkBlue-50 min-h-96 mb-5 pb-5'}>
      <Div className={'items-center justify-center self-start rounded w-full pt-4 pb-6'}>
        <Div className={'relative w-1/2 md:w-4/6 h-48'}>
          {image}
        </Div>
      </Div>
      <Div className={'flex-col px-7 pt-4 gap-4'}>
        <Text typography={'lg'} type={'bold'} className={'truncate'}>
          {title}
        </Text>
        <Text className={'truncate'}>
          {subTitle}
        </Text>
      </Div>
      <Div className={'p-2 sm:p-10 justify-center'}>
        <Button href={getParseRoute({ pathname: route, locale: lang })} onClick={handleClick} className={'w-full'}>
          {buttonTitle}
        </Button>
      </Div>
    </Div>
  );
};

export default SliderItem;
